import { IMG, CHECKOUT_URL } from "../../lib/assets";
import { CTAButton } from "./CTAButton";

export const Hero = () => {
  return (
    <section
      className="relative min-h-screen w-full overflow-hidden flex items-center"
      data-testid="hero-section"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={IMG.hero}
          alt="J walking through the forest"
          className="img-warm w-full h-full object-cover opacity-40"
          data-testid="hero-image"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#FAF3F2]/80 via-[#FAF3F2]/70 to-[#FAF3F2]" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 py-32 text-center">
        <h1
          className="fade-up fade-up-delay-1 font-serif font-light text-6xl sm:text-7xl md:text-8xl lg:text-[9rem] leading-[0.95] tracking-tight text-[#3B2630]"
          data-testid="hero-heading"
        >
          The <span className="italic text-[#C9587E]">Goldmine</span>
        </h1>

        <div className="fade-up fade-up-delay-2 warm-divider my-12" />

        <div className="fade-up fade-up-delay-2 max-w-2xl mx-auto">
          <p className="font-serif text-2xl md:text-4xl text-[#3B2630] leading-snug">
            I&rsquo;ve worked with enough women to know that you want the
            success but you will never <span className="italic">EVER</span> again
            burn yourself out to get it&hellip;
          </p>
          <p className="font-serif italic text-3xl md:text-5xl text-[#C9587E] mt-10 leading-snug">
            Good. Me too.
          </p>
        </div>

        <div className="fade-up fade-up-delay-4 mt-16 flex items-center justify-center">
          <CTAButton variant="primary" href={CHECKOUT_URL} testid="hero-cta">
            Nuff Said.
          </CTAButton>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-3">
        <span className="font-body uppercase tracking-[0.3em] text-[10px] text-[#97808A]">
          Read on
        </span>
        <div className="w-px h-12 bg-gradient-to-b from-[#C9587E]/60 to-transparent" />
      </div>
    </section>
  );
};
